import { Controller } from "@hotwired/stimulus"

// AzioneLicenza di pages/Piani.js. Campi per azione (piano per attiva/rinnova/cambio, con «Demo» solo per attiva;
// quante per pratiche/utenti; inizio per attiva/rinnova); un cambio toglie il calcolo e la scelta degli utenti
// (cambia). Al rinnovo ogni casella degli utenti proposti ricalcola subito (scegliUtenti). Il pagamento compare con un
// importo; «Conferma» si accende solo con gli utenti scelti e, se c'è da pagare, data e riferimento scritti, e chiede
// il riepilogo con confirm().
const METODI = { bonifico: "bonifico", carta: "carta", paypal: "PayPal" }
const data = (d) => (d ? new Date(String(d).length <= 10 ? `${d}T00:00:00` : d).toLocaleDateString("it-IT") : "—")

export default class extends Controller {
  static targets = ["azione", "piano", "sceltaPiano", "vuota", "demo", "quante", "inizio", "calcola", "utentiRinnovo", "risultato",
    "pagamento", "metodo", "data", "riferimento", "mancante", "conferma", "iconaLavoro", "iconaConferma"]

  connect() {
    this.lavoro = false
    this.campi()
    this.aggiorna()
  }

  // cambia(k, x): setF({ ...f, [k]: x, utenti_rinnovo: null }); setCalc(null)
  cambia() {
    this.campi()
    this.utentiRinnovoTarget.value = ""
    const r = this.risultatoTarget
    r.replaceChildren()
    r.hidden = true
    r.dataset.calcolo = "no"
    this.aggiorna()
  }

  campi() {
    const azione = this.azioneTarget.value
    this.pianoTarget.hidden = !["attiva", "rinnova", "cambio"].includes(azione)
    this.quanteTarget.hidden = !["pratiche", "utenti"].includes(azione)
    this.inizioTarget.hidden = !["attiva", "rinnova"].includes(azione)
    this.vuotaTarget.textContent = azione === "rinnova" ? "Lo stesso (o quello scelto per il rinnovo)" : "Scegli…"
    this.demo(azione === "attiva")
  }

  // La Demo solo per «Attiva»: tolta dal select per le altre azioni; se era scelta resta la prima voce, che è anche
  // il valore inviato (React mostrava la prima voce ma inviava ancora "demo").
  demo(presente) {
    if (!this.hasDemoTarget) return
    const select = this.sceltaPianoTarget
    const opzione = select.querySelector("option[data-demo]")
    if (presente && !opzione) {
      const nuova = this.demoTarget.content.firstElementChild.cloneNode(true)
      select.insertBefore(nuova, select.options[Number(this.demoTarget.dataset.indice)] || null)
    } else if (!presente && opzione) {
      const scelta = opzione.selected
      opzione.remove()
      if (scelta) select.selectedIndex = 0
    }
  }

  // scegliUtenti(e.target.checked ? i : i - 1)
  scegli({ currentTarget, params: { numero } }) {
    this.ricalcola(currentTarget.checked ? numero : numero - 1)
  }

  tutti({ params: { numero } }) {
    this.ricalcola(numero)
  }

  ricalcola(n) {
    this.utentiRinnovoTarget.value = String(n)
    this.element.requestSubmit(this.calcolaTarget)
  }

  risultatoTargetConnected() {
    this.aggiorna()
  }

  aggiorna() {
    if (!this.hasConfermaTarget || !this.hasRisultatoTarget) return
    const r = this.risultatoTarget
    const calcolo = r.dataset.calcolo === "si"
    const totale = Number(r.dataset.totale || 0)
    const completo = !!(this.dataTarget.value && this.riferimentoTarget.value.trim())
    const daPagare = calcolo && totale > 0
    this.pagamentoTarget.hidden = !daPagare
    this.pagamentoTarget.disabled = !daPagare
    this.mancanteTarget.hidden = !(daPagare && !completo)
    this.confermaTarget.hidden = !calcolo
    this.confermaTarget.disabled = this.lavoro || r.dataset.daConfermare === "si" || (totale > 0 && !completo)
    this.iconaLavoroTarget.toggleAttribute("hidden", !this.lavoro)
    this.iconaConfermaTarget.toggleAttribute("hidden", this.lavoro)
  }

  conferma(event) {
    const r = this.risultatoTarget
    if (Number(r.dataset.totale || 0) > 0) {
      const testo = `Registri un pagamento di ${r.dataset.totaleEuro} ricevuto il ${data(this.dataTarget.value)} ` +
        `con ${METODI[this.metodoTarget.value]}, rif. ${this.riferimentoTarget.value.trim()}?`
      if (!window.confirm(testo)) event.preventDefault()
    }
  }

  inizio({ detail: { formSubmission } }) {
    if (formSubmission.submitter !== this.confermaTarget) return
    this.lavoro = true
    this.aggiorna()
  }

  fine() {
    this.lavoro = false
    this.aggiorna()
  }
}
